import transitionEnd from './transition-end';

class Accordion {
  private isOpen: boolean;

  private readonly btn: HTMLElement;

  private readonly btnChevIcon: HTMLElement;

  private readonly container: HTMLElement;

  private readonly content: HTMLElement;

  constructor(element: HTMLElement) {
    this.container = element;
    this.btn = this.container.querySelector('[data-btn]');
    this.btnChevIcon = this.btn.querySelector('.icon--chev');
    this.content = this.container.querySelector('[data-content]');
    this.isOpen = !this.content.hidden;

    this.content.style.height = '0';

    if (this.isOpen && !this.btnChevIcon.classList.contains('rotate-180')) {
      this.btnChevIcon?.classList.add('rotate-180');
    }

    this.open = this.open.bind(this);
    this.close = this.close.bind(this);
    this.toggle = this.toggle.bind(this);

    this.btn.addEventListener('click', this.toggle);
  }

  open() {
    this.isOpen = true;

    this.btnChevIcon?.classList.add('rotate-180');

    this.content.hidden = false;
    this.content.style.height = `${this.content.scrollHeight}px`;
  }

  close() {
    this.isOpen = false;

    this.btnChevIcon?.classList.remove('rotate-180');

    this.content.style.height = '0';

    transitionEnd(this.content, () => {
      if (!this.isOpen) this.content.hidden = true;
    }, { once: true });
  }

  toggle() {
    this[this.isOpen ? 'close' : 'open']();
  }
}

export default (element: HTMLElement): Accordion => new Accordion(element);
